// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-alert[data-v-2d1df2c6]{font-size:14px;line-height:18px}.health-warnings p[data-v-2d1df2c6]{margin-bottom:16px}.health-warnings p[data-v-2d1df2c6]:last-child{margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
